/* eslint-disable @typescript-eslint/no-unused-vars */
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';
// RxJS
import { of } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';

import { ShipmentService } from '../../../../core/ronex/_services/shipment.service';

@Component({
  selector: 'kt-returned-delivered-chart',
  templateUrl: './returned-delivered-chart.component.html',
  styleUrls: ['./returned-delivered-chart.component.scss'],
})
export class ReturnedDeliveredChartComponent implements OnInit {
  @ViewChild('chartObj', { static: true }) chart: ChartComponent;
  public chartOptions: any;

  months: Array<string> = [
    'Ιαν',
    'Φεβ',
    'Μαρ',
    'Απρ',
    'Μαιος',
    'Ιουν',
    'Ιουλ',
    'Αυγ',
    'Σεπ',
    'Οκτ',
    'Νοε',
    'Δεκ',
  ];

  err = false;
  loading = false;

  constructor(
    private ss: ShipmentService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.chartOptions = {
      series: [
        {
          name: 'Παραδομένες',
          data: [], //[10, 41, 35, 51, 49, 62, 69, 91, 148]
        },
        {
          name: 'Επεστραμένες',
          data: [], //[16, 15, 15, 19, 22, 9, 12, 14,20]
        },
        {
          name: 'Εκκρεμούν',
          data: [], //[4, 3, 5, 9, 6, 6, 9, 14,2]
        },
      ],
      colors: ['#3396de', '#cb7d17', '#d53f3f'],
      chart: {
        height: 300,
        type: 'area',
      },
      title: {
        text: '',
      },
      markers: {
        size: 0,
      },
      yaxis: {
        floating: true,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        labels: {
          show: false,
        },
      },
      xaxis: {
        floating: true,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        labels: {
          show: false,
        },
        categories: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
        ],
      },
      grid: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
    };
    this.fetchData();
  }

  fetchData() {
    this.loading = true;
    this.err = false;
    this.ss
      .getRetDev()
      .pipe(
        take(1),
        tap(res => (this.loading = false)),
        tap(res => {
          this.chartOptions.xaxis.categories = res.delivered.map(
            x => this.months[x.month - 1] + ' ' + x.year
          );

          res.delivered.forEach(x => {
            if (
              res.neither.find(
                y => y.month === x.month && y.year === x.year
              ) === undefined
            ) {
              res.neither.push({ month: x.month, year: x.year, cn: 0 });
            }

            if (
              res.returned.find(
                y => y.month === x.month && y.year === x.year
              ) === undefined
            ) {
              res.returned.push({ month: x.month, year: x.year, cn: 0 });
            }
          });
          res.neither = res.neither.sort((a, b) => {
            if (a.year === b.year) {
              return a.month - b.month;
            } else {
              return a.year - b.year;
            }
          });

          res.returned = res.returned.sort((a, b) => {
            if (a.year === b.year) {
              return a.month - b.month;
            } else {
              return a.year - b.year;
            }
          });

          this.chartOptions.series[0].data = res.delivered.map(x => x.cn);
          this.chartOptions.series[1].data = res.returned.map(x => x.cn);
          this.chartOptions.series[2].data = res.neither.map(x => x.cn);
          this.chart.updateOptions(this.chartOptions);
        }),

        tap(res => this.cdr.detectChanges()),
        catchError(err => {
          this.err = true;
          this.loading = false;
          this.cdr.detectChanges();
          return of(null);
        })
      )
      .subscribe();
  }
}
